<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9,2C8.719999999999999,2,8.469999999999999,2.11,8.29,2.29C8.29,2.29,5.59,5,5.59,5C5.59,5,3,5,3,5C2.45,5,2,5.45,2,6C2,6,2,10,2,10C2,10.55,2.45,11,3,11C3,11,5.59,11,5.59,11C5.59,11,8.3,13.71,8.3,13.71C8.469999999999999,13.89,8.719999999999999,14,9,14C9.55,14,10,13.55,10,13C10,13,10,3,10,3C10,2.45,9.55,2,9,2C9,2,9,2,9,2ZM12.57,3.44C12.57,3.44,10.98,4.66,10.98,4.66C11.62,5.609999999999999,12,6.76,12,8C12,9.24,11.62,10.39,10.98,11.34C10.98,11.34,12.57,12.56,12.57,12.56C13.47,11.27,14,9.7,14,8C14,6.3,13.47,4.73,12.57,3.44C12.57,3.44,12.57,3.44,12.57,3.44Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'VolumeDown',
} as DefineComponent
</script>
